import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';
import { Production } from 'src/models/Management.interface';
import { SortOrder } from 'src/models/Sort.types';

interface ProductionQueryParams {
  offset: number;
  limit: number;
  search: string;
  sortBy: string;
  order: SortOrder;
  productId?: string;
  startDate?: string;
  endDate?: string;
}

export const getAllProductions = async (
  offset: number,
  limit: number,
  search: string,
  sortBy: string,
  order: SortOrder,
  productId?: string,
  startDate?: Date | null,
  endDate?: Date | null
): Promise<{
  data: Production[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}> => {
  const params: ProductionQueryParams = {
    offset,
    limit,
    search,
    sortBy,
    order,
  };

  if (productId) {
    params.productId = productId;
  }

  if (startDate) {
    params.startDate = startDate.toISOString().split('T')[0];
  }

  if (endDate) {
    params.endDate = endDate.toISOString().split('T')[0];
  }

  const response = await axiosTokenInstance.get(
    `${apiUrls.PRODUCTION_MANAGEMENT}/list`,
    {
      params,
      withCredentials: true,
    }
  );
  return response.data;
};

export const getProductionById = async (id: string): Promise<Production> => {
  const response = await axiosTokenInstance.get(
    `${apiUrls.PRODUCTION_MANAGEMENT}/${id}`
  );
  return response.data;
};

export const addProduction = async (payload: {
  productId: string;
  producedQuantity: number;
  damagedQuantity: number;
  productionDate: string;
}): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.post(
    apiUrls.PRODUCTION_MANAGEMENT,
    payload
  );
  return response.data;
};

export const editProduction = async (payload: {
  id: string;
  productId: string;
  producedQuantity: number;
  damagedQuantity: number;
  productionDate: string;
}): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.put(
    apiUrls.PRODUCTION_MANAGEMENT,
    payload
  );
  return response.data;
};

export const deleteProduction = async (
  id: string,
  deletedReason: string
): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.delete(
    `${apiUrls.PRODUCTION_MANAGEMENT}/${id}`,
    {
      data: { deletedReason },
    }
  );
  return response.data;
};
